import tmhRequest from '@/config/tmhRequest'

export default {

    searchMarket: function (data) {
        return tmhRequest({
            url: '/market/tmh/market/searchmarket',
            method: 'post',
            params: data,
        })
    },

    searchMarketCount: function (data) {
        return tmhRequest({
            url: '/market/tmh/market/searchmarketcount',
            method: 'post',
            params: data,
        })
    },

    searchMarketByPage: function (data) {
        return tmhRequest({
            url: '/market/tmh/market/searchmarketbypage',
            method: 'post',
            params: data,
        })
    },

    addMarket: function (data) {
        return tmhRequest({
            url: '/market/tmh/market/addmarket',
            method: 'post',
            data: data,
        })
    },

    editMarket: function (data) {
        return tmhRequest({
            url: '/market/tmh/market/editmarket',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/market/market.js